module.exports = __webpack_public_path__ + "img/wave.4e4eb856.png";